/* Diver Bubbles — mega menu: open on hover, close when the pointer leaves.
   Loaded on EVERY page via snippets/header-mega-menu.liquid (the homepage
   also binds this from db-home.js; the per-<details> guard keeps it idempotent).
   A closed <details> renders no content, so hover toggles the [open] attribute
   directly; the open animation lives in db-mega.css. Mouse clicks on the label
   are neutralised so a click can't stick the panel; keyboard/touch stay native. */
(function () {
  if (window.__dbMegaHover) return;
  window.__dbMegaHover = true;

  var finePointer = window.matchMedia('(pointer: fine)').matches;

  function bind() {
    if (!finePointer) return;
    document.querySelectorAll('.header__inline-menu details.mega-menu').forEach(function (details) {
      if (details.dataset.dbHoverBound) return;
      details.dataset.dbHoverBound = '1';
      var summary = details.querySelector('summary');
      var li = details.closest('li') || details;
      var closeTimer = null;
      var openNow = function () {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach(function (d) {
          if (d !== details) d.removeAttribute('open');
        });
        if (!details.hasAttribute('open')) details.setAttribute('open', '');
      };
      var closeSoon = function () {
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          details.removeAttribute('open');
          closeTimer = null;
        }, 140); /* grace period for the summary -> panel gap */
      };
      li.addEventListener('mouseenter', openNow);
      li.addEventListener('mouseleave', closeSoon);
      if (summary) {
        summary.addEventListener('mousedown', function (e) { e.preventDefault(); });
        summary.addEventListener('click', function (e) { if (e.detail !== 0) e.preventDefault(); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', bind);
})();

/* Water-ripple pointer tracking for the hero CTAs — writes the cursor
   position into --rx/--ry; db-mega.css draws the expanding rings. Also
   injects an SVG turbulence/displacement filter (#db-water) so the waves
   visibly DISTORT the button surface on hover; db-mega.css only applies
   the filter when <html> carries .db-water, so a missing filter can never
   blank the buttons. */
(function () {
  if (window.__dbRipple) return;
  window.__dbRipple = true;
  if (!window.matchMedia('(pointer: fine)').matches) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ensureWaterFilter() {
    if (reduced) return;
    if (!document.getElementById('db-water-defs')) {
      /* Build the SVG through a plain <div> innerHTML: the HTML parser applies
         foreign-content rules to <svg>, so the filter primitives land in the
         real SVG namespace and actually run (setting innerHTML directly on a
         createElementNS'd <svg> is unreliable across browsers). */
      var wrap = document.createElement('div');
      wrap.id = 'db-water-defs';
      wrap.setAttribute('aria-hidden', 'true');
      wrap.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
      wrap.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="0" height="0">' +
        '<filter id="db-water" x="-35%" y="-60%" width="170%" height="220%">' +
        '<feTurbulence type="fractalNoise" baseFrequency="0.018 0.06" numOctaves="2" seed="7" result="n">' +
        '<animate attributeName="baseFrequency" dur="4.5s" values="0.018 0.06;0.032 0.09;0.018 0.06" repeatCount="indefinite"/>' +
        '</feTurbulence>' +
        '<feDisplacementMap in="SourceGraphic" in2="n" scale="18" xChannelSelector="R" yChannelSelector="G"/>' +
        '</filter></svg>';
      document.body.appendChild(wrap);
    }
    document.documentElement.classList.add('db-water');
  }

  function bindRipple() {
    /* hero CTAs (flare + ghost) plus every red flare CTA site-wide (showcase, printlab...) */
    var btns = document.querySelectorAll('.db-hero .db-btn, .db-btn--flare');
    if (!btns.length) return;
    ensureWaterFilter();
    btns.forEach(function (btn) {
      if (btn.dataset.dbRippleBound) return;
      btn.dataset.dbRippleBound = '1';
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        btn.style.setProperty('--rx', (e.clientX - r.left).toFixed(1) + 'px');
        btn.style.setProperty('--ry', (e.clientY - r.top).toFixed(1) + 'px');
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindRipple);
  } else {
    bindRipple();
  }
  document.addEventListener('shopify:section:load', bindRipple);
})();
